import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CartItem {
  // customItems: never[];
  portionSize: string;
  itemType: string;
  id: any;
  tinyId?: number;
  skuId?: string;
  productId?: string;
  name: string;
  price: number;
  description: string;
  imageUrl: string;
  quantity: number;
  customItems: { menuItemId: string; displayName: string; unitPrice: number; imageUrl?:string }[];
  extraItems?: { menuItemId: string; displayName: string; unitPrice: number; imageUrl?:string }[];
  menuId?: string;
  servingTime?: string;
  supportsPreOrdering?: boolean;
  availableDays?: number[];
  orderClosingTime?: string;
  maxDaysToScheduleAhead?: number;
  customItemTotal?: number; // Total price of custom menu including extras
}

interface CartState {
  localCartList: CartItem[];
}

const initialState: CartState = {
  localCartList: [],
};

const cartSlice = createSlice({
  name: "localCartList",
  initialState,
  reducers: {
    addItemToLocalCart: (state, action: PayloadAction<CartItem>) => {
      const { id, quantity } = action.payload;
      const existingItem = state.localCartList.find((item) => item.id === id);

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.localCartList.push(action.payload);
      }
    },

    updateLocalCartQuantity: (state, action: PayloadAction<{ id: string; quantity: number }>) => {
      const { id, quantity } = action.payload;
      const item = state.localCartList.find((item) => item.id === id);

      if (item) {
        item.quantity = quantity;
      }
    },

    removeItemFromLocalCart: (state, action: PayloadAction<{ id: string }>) => {
      state.localCartList = state.localCartList.filter((item) => item.id !== action.payload.id);
    },

    clearOrderList: (state) => {
      state.localCartList = [];
    },
    updateItemInLocalCart: (state, action: PayloadAction<CartItem>) => {
      const { id } = action.payload;
      const index = state.localCartList.findIndex((item) => item.id === id);

      if (index !== -1) {
        state.localCartList[index] = action.payload;
      } else {
        console.warn("Item not found in cart. Cannot update.");
      }
    },
  },
});

export const { addItemToLocalCart, updateLocalCartQuantity, removeItemFromLocalCart, clearOrderList, updateItemInLocalCart } = cartSlice.actions;
export default cartSlice.reducer;